import { render } from "./UploadCost.vue?vue&type=template&id=0cb3c5c2"
import script from "./UploadCost.vue?vue&type=script&lang=js"
export * from "./UploadCost.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__